import { Navbar } from "@/components/modules/Navigation/Navbar/Navbar";
import { commonLanguageFiles } from "@/config";
import { LanguageProvider } from "@/contexts/LanguageProvider";
import { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import ForgetPasswordForm from "components/modules/Auth/Forget/ForgetPasswordForm";
import { ReduxProvider } from "components/common/ReduxProvider/ReduxProvider";

const ForgetPasswordPage = () => {
    return (
        <div className="w-full text-black max-w-1440 page-shadow dark:text-white min-h-screen flex flex-col">
            <Navbar url={"/forget"} />
            <div className="flex-1 flex items-center justify-center">
                <div className="dark:bg-darkSurface-100 box-border w-full max-w-[24rem] p-8 space-y-6 bg-white shadow-[0_0_30px_rgba(0,0,0,0.1)] rounded-lg">
                    <ForgetPasswordForm />
                </div>
            </div>
        </div>
    );
};

const LanguageWrapper = () => {
    return (
        <LanguageProvider files={files}>
            <ReduxProvider>
                <ForgetPasswordPage />
            </ReduxProvider>
        </LanguageProvider>
    );
};

export default LanguageWrapper;

const files = ["forget-password", "auth", ...commonLanguageFiles];

export const getStaticProps: GetStaticProps = async ({ locale }) => {
    return {
        props: {
            ...(await serverSideTranslations(locale ?? "", files)),
        },
    };
};
